<template>
  <div>
    <main>
      <section>
        <div class="">
          <div class="row stat-tiles">

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Formal Sector Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ total | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-activity"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Accredited Health Facilities</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.providers | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-user-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Civil Servant</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.state_civil | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/#' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Universal Basic Education</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.ubec | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">ZIRS</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ zirs_count | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/#' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-danger rounded-circle text-danger">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents State Civil Servants</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_dynamic | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>


            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/#' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents LGA Civil Servants</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_lga_civil_servants | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>


              <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/#' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents UBEC</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.dependants_ubec | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>


            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/#' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">LGA Civil Servant</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.lga_civil | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-clipboard"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Claims</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.claims }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                  <i class="fe fe-file-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Encounters</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ formaldata.encounters }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>
          </div>

          <div class="container col-md-12 mb-5">
            <div class="row">
              <router-link to="export-date">
                <button class="btn btn-outline-info mr-2">
                  Filter Enrollee Date
                </button>
              </router-link>

              <router-link to="export-provider">
                <button class="btn btn-outline-dark">
                  Filter Enrollee Provider
                </button>
              </router-link>
            </div>
          </div>

          <div>
            <FormalSectorChartByLGA />
          </div>

          <div>
            <DependentsByLGAChart />
          </div>

          <div>
            <MDAData />
          </div>

          <div class="row">
            <div class="col-md-12 p-t-20">
              <h5 class="h5">
                <i class="fe fe-activity"></i>Gender Distribution by LGA
              </h5>
            </div>

            <div class="col-md-12">
              <div class="card table-card shadow mb-4">
                <div class="card-body">
                  <GenderbyLGA :sectors="sectors" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import MDAData from "./mda";
import GenderbyLGA from "./GenderbyLGA";
import FormalSectorChartByLGA from "./FormalSectorChartByLGA";
import DependentsByLGAChart from "./DependentsByLGAChart";

export default {
  components: {
    GenderbyLGA,
    MDAData,
    FormalSectorChartByLGA,
    DependentsByLGAChart,
  },

  data() {
    return {
      user: null,
      sectors: [
        {
          name: "State Civil Servant",
        },
        {
          name: "Universal Basic Education",
        },
        {
          name: "LGA Civil Servant",
        },
      ],
      mydata: "",
      formaldata: "",
      total: 0,
      zirs_count: 0,
      auth_user: "",
      providers: "",
      clients: "",
      total_clients: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.$batchGet("/api/v1/auth/getformalsectorenrollees/4")
      .then((response) => {
        this.formaldata = response.data;
        this.total =
          response.data.state_civil +
          response.data.ubec +
          response.data.dependants_dynamic +
          response.data.dependants_lga_civil_servants +
          response.data.dependants_ubec +
          response.data.lga_civil;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });

    this.$batchGet("/api/v1/auth/getUsersfilterparams", {
        params: {
          agency_id: 4,
          place_of_work: "ZIRS",
          enabled_user: 1,
          perPage: 1,
        },
      })
      .then((response) => {
        this.zirs_count = response.data.meta.total;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    totalFormal() {
      let total = this.formaldata.enrollees + this.formaldata.dependants;
      return total;
    },
  },

  methods: {},
  created() {},
};
</script>
<style lang="css" scoped>
.spacer-top {
  margin-top: 10px;
}
</style>
